/*
 * Copyright (c) 2019. Willker Gomes
 */

import { productPaths } from '~/routes/paths';
import ProductSoftware from '~/pages/Product/Software';
import AddProductSoftware from '~/pages/Product/Software/AddSoftware';
import EditProductSoftware from '~/pages/Product/Software/EditSoftware';
import ProductModality from '~/pages/Product/Modality';
import AddProductModality from '~/pages/Product/Modality/AddModality';
import EditProductModality from '~/pages/Product/Modality/EditModality';
import ProductModule from '~/pages/Product/Module';
import AddProductModule from '~/pages/Product/Module/AddModule';
import EditProductModule from '~/pages/Product/Module/EditModule';

import permissions from '~/util/permissions';

const productRoutes = [
  {
    key: 1,
    exact: true,
    hideSidebar: false,
    name: 'Software',
    path: productPaths.productSoftware,
    component: ProductSoftware,
    permission: permissions.view_software,
  },
  {
    key: 2,
    exact: false,
    hideSidebar: true,
    name: 'Adicionar Software',
    path: productPaths.addProductSoftware,
    component: AddProductSoftware,
    permission: permissions.create_software,
  },
  {
    key: 3,
    exact: false,
    hideSidebar: true,
    name: 'Editar Software',
    path: productPaths.editProductSoftware,
    component: EditProductSoftware,
    permission: permissions.edit_software,
  },
  {
    key: 4,
    exact: true,
    hideSidebar: false,
    name: 'Modalidade',
    path: productPaths.productModality,
    component: ProductModality,
    permission: permissions.view_modalidade,
  },
  {
    key: 5,
    exact: false,
    hideSidebar: true,
    name: 'Adicionar Modalidade',
    path: productPaths.addProductModality,
    component: AddProductModality,
    permission: permissions.create_modalidade,
  },
  {
    key: 6,
    exact: false,
    hideSidebar: true,
    name: 'Editar Modalidade',
    path: productPaths.editProductModality,
    component: EditProductModality,
    permission: permissions.edit_modalidade,
  },
  {
    key: 7,
    exact: true,
    hideSidebar: false,
    name: 'Módulo',
    path: productPaths.productModule,
    component: ProductModule,
    permission: permissions.view_modulo,
  },
  {
    key: 8,
    exact: false,
    hideSidebar: true,
    name: 'Adicionar Módulo',
    path: productPaths.addProductModule,
    component: AddProductModule,
    permission: permissions.create_modulo,
  },
  {
    key: 9,
    exact: false,
    hideSidebar: true,
    name: 'Editar Módulo',
    path: productPaths.editProductModule,
    component: EditProductModule,
    permission: permissions.edit_modulo,
  },
];

export default productRoutes;
